import type { FeatureRoute } from '../types';
import { AccountPage } from './AccountPage';
import { MfaSetupPage } from './MfaSetupPage';

/** Account screens (A1). The forced MFA setup (`/setup-mfa`) lives outside the shell in App.tsx. */
export const routes: FeatureRoute[] = [
  { path: 'account', element: <AccountPage /> },
  { path: 'account/mfa', element: <MfaSetupPage /> },
];
